import loadable from '@loadable/component';

export const DefaultSiteWrapper = loadable(
  () => import(/* webpackChunkName: "default-site" */ './DefaultSiteWrapper'),
);
